var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-backtop',_vm._b({staticClass:"sjx-backtop"},'el-backtop',_vm.$attrs,false),[_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/ShuJiuXiang/backtop@2x.png"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }